var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"checkbox",on:{"click":_vm.update}},[(_vm.checked)?_c('dean-icon',{staticClass:"checked",attrs:{"glyph":_vm.checkboxCheckedIcon,"width":_vm.width}}):_c('dean-icon',{staticClass:"unchecked",attrs:{"glyph":_vm.checkboxUncheckedIcon,"width":_vm.width}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }